import * as CLIENTS_TYPES from './types';

export const getClientSubscriptions = ({ clientId }) => ({
    type: CLIENTS_TYPES.CLIENT_ITEM_SUBSCRIPTIONS_GET,
    payload: { clientId },
});
